
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Stratégie de génération de leads : comment en attirer plus ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez des stratégies efficaces pour générer des leads, multiplier vos contacts et optimiser votre taux de conversion afin de développer votre clientèle.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Stratégie : comment générer des leads ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Vous voulez accroître votre nombre de clients. Avez-vous mis en place une stratégie pour obtenir des leads ? Cet article vous délivre conseils et astuces pour multiplier les contacts et maximiser votre taux de conversion.",
        },
      ],
    };
  },
};
